import { createSelector } from 'reselect';

const selector = (state, projectId) => {
  return state.taskForms.items.filter(i => i.project_id === projectId)
                              .asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/task-forms-selector.js